import script from "./BriefcaseWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./BriefcaseWidget.vue?vue&type=script&setup=true&lang=js"

import "./BriefcaseWidget.vue?vue&type=style&index=0&id=ef002e48&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef002e48"]])

export default __exports__